<template>
    <div data-test-view="org-chart">
        <l-card-content full>
            <l-headline :title="$t(`profile.titleOrgChart`, { name: teamName })" :tabs="tabs" />

            <l-no-data
                v-if="!data"
                :text="
                    user.rights.A_USER
                        ? $t(`profile.orgChartNoDataTextAdmin`)
                        : $t(`profile.orgChartNoDataText`)
                "
                :btn-show="user.rights.A_USER"
                :btn-text="$t(`profile.orgChartNoDataButton`)"
                :btn-handler="() => $router.push(`/team/members`)"
            />

            <l-org-chart v-else :data="data" :config="{ zoom }" />
        </l-card-content>
    </div>
</template>

<script>
import { mapGetters } from "vuex";

import LCardContent from "@/components/LCardContent";
import LHeadline from "@/components/LHeadline";
import LNoData from "@/components/LNoData";
import LOrgChart from "@/components/LOrgChart";

import iconRocket from "@/img/icons/rocket.png";

export default {
    components: {
        LCardContent,
        LHeadline,
        LNoData,
        LOrgChart,
    },
    data() {
        return {
            zoom: 1.25,
            step: 0.05,
        };
    },
    computed: {
        ...mapGetters({
            user: "users/current/user",
            rights: "users/current/rights",
            teamSettings: "users/current/teamSettings",
            getOrgChartData: "teams/current/orgChart",
        }),
        teamName() {
            return this.teamSettings.name;
        },
        data() {
            const orgChartData = this.getOrgChartData();

            if (!orgChartData.length) {
                return null;
            }

            // Only one root element, all good!
            if (orgChartData.length === 1) {
                return orgChartData[0];
            }

            // Multiple root elements, append company's vision as root
            return {
                name: this.teamSettings.name,
                title: this.teamSettings.vision,
                children: orgChartData,
                picture: iconRocket,
                _id: "root",
            };
        },
        tabs() {
            return [
                {
                    label: this.$t(`profile.btnBackToProfile`),
                    path: `/profile`,
                    icon: `fal fa-caret-left`,
                    iconBeforeLabel: true,
                    show: true,
                },
                {
                    label: this.$t(`profile.helpNavigate`),
                    icon: `fal fa-hand-pointer`,
                    iconBeforeLabel: true,
                    tabClass: "descriptive",
                    show: true,
                },
                {
                    label: "",
                    icon: `fal fa-search-plus`,
                    handler: this.zoomIn,
                    tabClass: "color-primary",
                    show: true,
                },
                {
                    label: "",
                    icon: `fal fa-search-minus`,
                    handler: this.zoomOut,
                    tabClass: "color-primary",
                    show: true,
                },
            ];
        },
    },
    created() {
        // If current user is not allowed to view org-chart and is not an admin, redirect to profile
        if (!(this.rights.P_ORG || this.rights.A_USER)) {
            this.$router.replace("/profile");
        }
    },
    methods: {
        zoomIn() {
            this.zoom += this.step;
        },
        zoomOut() {
            if (this.zoom <= this.step) {
                return;
            }

            this.zoom -= this.step;
        },
    },
};
</script>

<style scoped></style>
